module.exports = __webpack_public_path__ + "img/img-3.bdb1c3f8.png";